import "./HowUseCard.css";

export function HowUseCard({image, text, title}) {
  return (
    <div className="how-use-card">
      <div className="box">
        <img width={"22px"} src={image} alt="" />
      </div>

        <div className="content-card">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
    </div>
  );
}